export { MainLayout } from './Layout';
export { Link } from './Link';
export { SpeedSlider } from './SpeedSlider';
export { CheckTag } from './CheckTag';
export { CustomIcon } from './CustomIcon';
export { RoundChart } from './RoundChart';
export { AddressView } from './AddressView';
export { Modal } from './Modal';
export { Input } from './Input/index';
export { FileDropzone } from './FileDropzone';
export { Toast } from './Toast';
export { Map } from './Map/index';
export { Switch } from './Switch';
export { AprroveCustomizeIcons } from './AprroveCustomizeIcons';
export { Badge } from './Badge';



// WEBPACK FOOTER //
// ./src/view/common/index.js